module.exports = __webpack_public_path__ + "assets/52df702db98aa7138730d8ef06b3a71c.woff2";


//////////////////
// WEBPACK FOOTER
// ../~/@fontsource/roboto/files/roboto-greek-700-normal.woff2
// module id = 2629
// module chunks = 121